// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__30ymT","row":"ProcedureTreatmentSummary_row__2UPhJ"};